/**
 * PlatformHome — Home FinOps do admin global.
 *
 * Reusa o corpo compartilhado (`FinopsHomeBody`) com os mesmos widgets do
 * gestor — o backend já entrega o agregado global para admin (sem poda). Anexa,
 * via `footerSlot`, a visão por organização (`PortfolioTable`), as contas não
 * mapeadas (visíveis só a admin — SP0 §2.6) e o link para os relatórios
 * org-wide.
 */
import { Stack, Alert, Group, Anchor } from '@mantine/core'
import { IconBuildingBank, IconExternalLink } from '@tabler/icons-react'
import { Link } from 'react-router-dom'
import { FinopsHomeBody } from './ManagerHome'
import { PortfolioTable } from '@/components/finops/widgets/PortfolioTable'
import { formatMoney } from '@/components/finops/formatMoney'
import type { PortfolioResponse } from '@/api/finopsDashboard'

export function PlatformHome() {
  return (
    <FinopsHomeBody
      title="FinOps — Plataforma"
      subtitle="Visão global de custos de todas as organizações"
      footerSlot={(portfolio: PortfolioResponse) => (
        <Stack gap="md">
          <PortfolioTable rows={portfolio.tenants} />

          {portfolio.unmapped_accounts.length > 0 && (
            <Alert
              color="orange"
              icon={<IconBuildingBank size={18} />}
              title="Contas não mapeadas"
            >
              {portfolio.unmapped_accounts.length} conta(s) AWS com custo sem
              organização vinculada:{' '}
              {portfolio.unmapped_accounts
                .map((u) => `${u.account_id} (${formatMoney(u.amount_usd)})`)
                .join(', ')}
            </Alert>
          )}

          <Group>
            <Anchor
              component={Link}
              to="/finops/reports"
              size="sm"
            >
              <Group gap={6} component="span">
                <IconExternalLink size={14} />
                Relatórios semanais (org-wide)
              </Group>
            </Anchor>
          </Group>
        </Stack>
      )}
    />
  )
}
